export const baseFetch = async (
    url: string,
    options: RequestInit,
    responseType: 'json' | 'raw' = 'json'
) => {
    try {
        const isFormData = options.body instanceof FormData;
        
        const config: RequestInit = {
            ...options,
            headers: {
                ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
                'X-Requested-With': 'XMLHttpRequest',
                ...options.headers,
            },
            credentials: 'include',
        };

        const response = await fetch(url, config);

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        if (responseType === 'json') {
            // Handle cases where response body might be empty or whitespace-only
            const text = await response.text();
            return text.trim() ? JSON.parse(text) : {};
        }

        return response;
    } catch (error) {
        throw error;
    }
};
